<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" /> -->
  </div>
</template>

<script>
import CheckInService from "@/api/CheckInService.js";
import statusBarHeight from "@/utils/StarisBarHeight.js";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },

  data() {
    return {
      isRouterAlive: true,
      userId: "",
    };
  },
  created() {
    // this.getUserInfos();
    // this.getRem(750,100)
  },
  mounted() {
    this.statusBarHeight
  },

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // async getUserInfo() {
    //   let phoneValue = localStorage.getItem("phone");
    //   let res = await CheckInService.getUserInfo(phoneValue);
    //   // let res = await CheckInService.getUserInfo('13853794288');
    //   if (res.result == "OK") {
    //     if (res.response.DataModel.isValid != 1) {
    //       this.$router.push({ path: "/disable" });
    //     } else {
    //     }
    //   }
    // },
    // async getUserInfos() {
    //   var that = this;
    //   let phoneValue = that.$route.query.username;
    //   // 正式
    //   localStorage.setItem("phone", phoneValue);
    //   // alert(this.$route.query.username);
    //   // 测试
    //   // localStorage.setItem("phone", "13853794288");

    //   //测试
    //   // let res = await CheckInService.getUserInfo("13853794288");
    //   //正式
    //   let res = await CheckInService.getUserInfo(phoneValue);

    //   // let res = await CheckInService.getUserInfo('13853794288');
    //   if (res.result == "OK") {
    //     that.userId = res.response.DataModel.id;
    //     localStorage.setItem("userId", that.userId);
    //     // localStorage.setItem("userId", '13853794288');
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
// @import "@/assets/css/public.css";

#app::-webkit-scrollbar {
  width: 0 !important;
}
#app {
  -ms-overflow-style: none;
}
#app {
  overflow: -moz-scrollbars-none;
  position: relative;
}
.custom_html{
	video{
		width: 100% !important;
	}
}
>>> .el-message__group>.el-message__content {
  color: #3eaf7c !important; /* 更改文字颜色 */
}

>>> .el-message.el-message--success {
  background-color: #ecf5f0 !important; /* 更改背景颜色 */
  border-color: #b7ebd5 !important; /* 更改边框颜色 */
}

/* 或者使用 ::v-deep */
::v-deep .el-message__group>.el-message__content {
  color: #3eaf7c !important;
}

::v-deep .el-message.el-message--success {
  background-color: #ecf5f0 !important;
  border-color: #b7ebd5 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue